module.exports = __webpack_public_path__ + "img/cloture-autre.5e1917c.svg";